function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "stats-bars",
  transform: "translate(-5.625 4.909)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11827",
  "data-name": "Path 11827",
  d: "M12.375,6.75h4.916V25H12.375Z",
  transform: "translate(0.624 3.265)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11828",
  "data-name": "Path 11828",
  d: "M5.625,22.5h4.916v7.374H5.625Z",
  transform: "translate(0 -1.609)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11829",
  "data-name": "Path 11829",
  d: "M19.125,18h4.916V30.291H19.125Z",
  transform: "translate(1.249 -2.025)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11830",
  "data-name": "Path 11830",
  d: "M25.875,13.5h4.916V39.482H25.875Z",
  transform: "translate(1.873 -11.217)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_269",
  "data-name": "Line 269",
  y1: 8.862,
  x2: 6.817,
  transform: "translate(8.324 3.194)",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_270",
  "data-name": "Line 270",
  x1: 7.498,
  y1: 4.09,
  transform: "translate(15.14 3.194)",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11831",
  "data-name": "Path 11831",
  d: "M0,16.253H0L5.392,6.089",
  transform: "translate(22.639 -8.97)",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeWidth: 3
}));

var SvgStatsBars = function SvgStatsBars(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.04,
    height: 33.175,
    viewBox: "0 0 27.04 33.175",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStatsBars, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stats-bars.642560de.svg";
export { ForwardRef as ReactComponent };